__webpack_require__.p = "https://pathtotheplayoffs.uk.nfl.com/";